import React from "react"

export default function({
  name,
  addressOne,
  addressTwo,
  isPickup,
  pickupInstructions
}) {
  const addForAll = [...addressOne, ...addressTwo]
  const oneAddressForAll = addForAll.filter(a => a && a !== "").join(", ")
  return (
    <div className="shipping-display border-bottom">
      <div className="space-between">
        <div className="bold">{isPickup ? "Pickup:" : "Ship to:"}</div>
        <div className="address">
          <span>{name}</span>
          {(oneAddressForAll !== "" && (
            <>
              <span>{oneAddressForAll}</span>
            </>
          )) || <span>N/A</span>}
        </div>
      </div>
      {isPickup &&
        pickupInstructions && (
          <div className="space-between instructions">
            <div className="bold">Instructions for Customer:</div>
            <div>{pickupInstructions}</div>
          </div>
        )}
    </div>
  )
}
